import { navigation } from '@/app'
import { CommunitySearchModal } from '@/components'
import { APIClient } from '@/services'
import { analytics } from '@/services/analytics/segment'
import { useIsMobile } from '@/utils'
import { useCallback } from 'react'
import { FeedCommentDrawer } from '../CommentList'
import { ActionButton } from './ActionButton'

export const SearchButton = () => {
  const isMobile = useIsMobile()
  const drawerVisible = FeedCommentDrawer.useIsVisible()

  const onSearch = useCallback(() => {
    const authorized = APIClient.UnknownProfile.maybeOpenRegistrationWall(true, false, 'community-search')

    if (!authorized) return

    analytics.track('feed_search_start')

    if (isMobile) {
      return navigation.navigate('Feed.Search')
    }

    return CommunitySearchModal.open()
  }, [isMobile])

  return (
    <ActionButton
      icon="search"
      onPress={onSearch}
      iconStyle={{ width: 24, height: 24 }}
      style={{
        position: 'absolute',
        top: 24,
        right: 24,
        transition: 'all 0.2s',
        zIndex: 10
      }}
    />
  )
}
